import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import { Label, FormHelp } from '@zillow/constellation';
import LabeledSelectField from '../../common/LabeledSelectField.js';
import { SELF_REPORTED_CREDIT } from '../../../constants.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CREDIT_OPTIONS = Object.entries(SELF_REPORTED_CREDIT).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return {
    label: value,
    value: key
  };
});
var CreditSelectField = function CreditSelectField(props) {
  return /*#__PURE__*/jsxRuntime.jsx(LabeledSelectField, _objectSpread({
    renderLabel: function renderLabel(labelProps) {
      return /*#__PURE__*/jsxRuntime.jsx(Label, _objectSpread(_objectSpread({}, labelProps), {}, {
        children: "Credit score"
      }));
    },
    helpText: "It\u2019s okay to estimate.",
    options: CREDIT_OPTIONS,
    description: /*#__PURE__*/jsxRuntime.jsx(FormHelp, {
      children: "It\u2019s okay to estimate."
    })
  }, props));
};
var CreditSelectField$1 = CreditSelectField;

export { CreditSelectField$1 as default };
//# sourceMappingURL=CreditSelectField.js.map
